import { TemplateIndexRedirectRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/template/')({
  component: TemplateIndexRedirectRoute,
});
